var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"secondary-button no-underline",class:_vm.getStyle,attrs:{"disabled":_vm.disabled},on:{"click":_vm.emitClick}},[_vm._t("icon"),_vm._v(" "+_vm._s(_vm.label)+" ")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }